import { LayoutGenerator } from "./utils/layoutGenerator"
import { Text } from "materials/text/menus/model"
import { Button } from "materials/button/menus/model"
import { Image } from "materials/image/menus/model"
import { Select } from "materials/select/menus/model"
import { Tabs } from "materials/tabs/menus/model"
import { Input } from "materials/input/menus/model"
import { Iframe } from "materials/iframe/menus/model"
import iconTel from "assets/images/login/icon-tel.png"
import iconPassword from "assets/images/login/icon-password.png"
import iconSchool from "assets/images/login/icon-school.png"
import iconId from "assets/images/login/icon-id.png"
import iconTest from "assets/images/login/icon-test.png"
// import imgSrc from "../../assets/images/login/logo.png"

/**
 * 门户登陆默认配置数据
 */
export const home = [
  {
    styleName: "自由布局",
    thumbnail: require("assets/images/leftMenu/layout/layout_1.png"),
    pluginName: ["loginEngineComponentPlugin"],
    appId: "",
    background: [
      {
        color: "#FFFFFF",
        isThemeColor: false,
        label: "颜色",
        type: "color"
      }
    ],
    titleOptions: [
      {
        type: "top",
        isShow: true,
        height: 200,
        elementOptions: [
          {
            innerElement: "cxTabs",
            isActive: false,
            isShow: true,
            type: "classification",
            elementInLayoutId: 0,
            options: new Tabs({
              singleTabs: false,
              top: 130,
              left: 48,
              width: 360,
              height: 62,
              lineHeight: 52,
              hoverLineHeight: 52,
              tabWidth: 180,
              tabHeight: 62,
              color: "#8A8B99",
              bgColor: "rgba(255,255,255,0)",
              hoverBgColor: "rgba(255,255,255,0)",
              hoverBgColorIsThemeColor: false,
              tabBackgroundColor: "rgba(255,255,255,0)",
              fontSize: 22,
              hoverFontSize: 22,
              textAlign: "center",
              hoverTextAlign: "center",
              tabsList: [
                { name: "手机号登录", content: "手机号登录", isHide: false, loginWay: 1 },
                { name: "扫码登录", content: "扫码登录", isHide: false, loginWay: 2 },
                { name: "机构账号登录", content: "机构账号登录", isHide: true, loginWay: 3 },
                { name: "短信验证码登录", content: "短信验证码登录", isHide: true, loginWay: 4 }
              ],
              hoverFontWeight: "500",
              hoverTextIsThemeColor: true,
              borderWidth: [0, 0, 1],
              borderColor: "#ECECF1",
              hoverBorderWidth: [0, 0, 2],
              textLimitLines: 7,
              hoverBorderIsThemeColor: true
            })
          },
          {
            innerElement: "imageComponent",
            isShow: true,
            type: "classification",
            elementInLayoutId: 1,
            options: new Image({
              top: 48,
              left: 132,
              width: 192,
              height: 44,
              imgSrc: "https://p.ananas.chaoxing.com/star3/origin/bcdbc474b726d89db32daa9c18e1bb51.png"
            })
          }
        ]
      },
      {
        type: "bottom",
        elementOptions: []
      },
      {
        type: "left",
        elementOptions: []
      },
      {
        type: "right",
        elementOptions: []
      }
    ],
    rows: new LayoutGenerator({
      // row的数量需与tab的数量同步
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              elementOptions: [
                new Input({
                  top: 40,
                  left: 48,
                  width: 360,
                  height: 48,
                  elementInLayoutId: 2,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconTel,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "手机号",
                  readonly: true,
                  loginType: "loginPhone"
                }),
                new Button({
                  top: 127,
                  left: 308,
                  width: 18,
                  height: 18,
                  zIndex: 2,
                  lineHeight: 48,
                  elementInLayoutId: 40,
                  content: "",
                  iconWidth: 18,
                  iconType: "icon",
                  iconSrc: "B4F974FFF34D7AA8",
                  iconColor: "#ACB4BF",
                  bgColor: "rgba(255, 255, 255,0)",
                  borderWidth: 0,
                  iconMargin: 0,
                  loginType: "loginShowHide",
                  background: [
                    {
                      "label": "颜色",
                      "isThemeColor": false,
                      "type": "color",
                      "color": "rgba(255, 255, 255,0)"
                    }
                  ],
                }),
                new Button({
                  top: 112,
                  left: 336,
                  width: 70,
                  height: 48,
                  zIndex: 2,
                  lineHeight: 48,
                  fontWeight: 400,
                  elementInLayoutId: 3,
                  content: "忘记密码",
                  color: "#6B89B2",
                  bgColor: "rgba(255, 255, 255,0)",
                  borderWidth: 0,
                  loginType: "loginForgetPassword",
                  background: [
                    {
                      "label": "颜色",
                      "isThemeColor": false,
                      "type": "color",
                      "color": "rgba(255, 255, 255,0)"
                    }
                  ],
                }),
                new Input({
                  top: 112,
                  left: 48,
                  width: 360,
                  height: 48,
                  elementInLayoutId: 4,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconPassword,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "密码",
                  inputTypeVal: "password",
                  readonly: true,
                  loginType: "loginPassword"
                }),
                new Text({
                  top: 168,
                  left: 48,
                  width: 360,
                  height: 34,
                  lineHeight: 34,
                  elementInLayoutId: 39,
                  fontSize: 14,
                  content: "手机号或密码不能为空！",
                  color: "#ff4e4e",
                  background: [
                    {
                      color: "rgb(255, 237, 237)",
                      isThemeColor: false,
                      label: "颜色",
                      type: "color"
                    }
                  ],
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  paddingLeft: 15,
                  paddingRight: 15,
                  borderWidth: 0,
                  loginType: "loginError"
                }),
                new Button({
                  top: 210,
                  left: 48,
                  width: 360,
                  height: 48,
                  fontSize: 18,
                  elementInLayoutId: 5,
                  content: "登录",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  bgColorIsThemeColor: true,
                  borderWidth: 0,
                  background: [
                    {
                      isThemeColor: true,
                      label: "颜色",
                      type: "color"
                    }
                  ],
                  loginType: "loginButton"
                }),
                new Text({
                  top: 278,
                  left: 48,
                  elementInLayoutId: 6,
                  content: "新用户注册",
                  fontSize: 15,
                  color: "#2675FA",
                  textIsThemeColor: true,
                  pointer: true,
                  loginType: "loginRegister"
                })
              ]
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              baseComponentBoxOptions: {
                bgColor: "#FFFFFF"
              },
              elementOptions: [
                new Iframe({
                  top: 40,
                  left: 118,
                  width: 220,
                  height: 260,
                  iframeUrl:
                    "https://passport2.chaoxing.com/cloudscanlogin?mobiletip=%E6%99%BA%E6%85%A7%E9%97%A8%E6%88%B7&pcrefer=",
                  elementInLayoutId: 7,
                  loginType: "loginCode"
                })
                // new Text({
                //   top: 360,
                //   left: 78,
                //   width: 300,
                //   elementInLayoutId: 8,
                //   content: "使用学习通app扫码登录",
                //   fontSize: 18,
                //   color: "#474C59",
                //   textAlign: "center",
                // }),
              ]
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              elementOptions: [
                // new Input({
                //   top: 40,
                //   left: 48,
                //   width: 360,
                //   height: 48,
                //   elementInLayoutId: 9,
                //   borderWidth: 1,
                //   borderColor: "#ECECF1",
                //   borderTopLeftRadius : 6,
                //   borderTopRightRadius : 6,
                //   borderBottomLeftRadius : 6,
                //   borderBottomRightRadius : 6,
                //   iconWidth: 24,
                //   iconType: "img",
                //   iconSrc: iconSchool,
                //   paddingLeft: 12,
                //   paddingRight: 12,
                //   placeholder: "学校/单位",
                //   loginType: "loginSchool"
                // }),
                new Input({
                  top: 40,
                  left: 48,
                  width: 360,
                  height: 48,
                  elementInLayoutId: 10,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconId,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "学号/工号",
                  readonly: true,
                  loginType: "loginId"
                }),
                new Input({
                  top: 112,
                  left: 48,
                  width: 360,
                  height: 48,
                  elementInLayoutId: 11,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconPassword,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "密码",
                  inputTypeVal: "password",
                  readonly: true,
                  loginType: "loginPassword"
                }),
                new Button({
                  top: 127,
                  left: 378,
                  width: 18,
                  height: 18,
                  zIndex: 2,
                  lineHeight: 48,
                  elementInLayoutId: 12,
                  content: "",
                  iconWidth: 18,
                  iconType: "icon",
                  iconSrc: "B4F974FFF34D7AA8",
                  iconColor: "#ACB4BF",
                  bgColor: "rgba(255, 255, 255,0)",
                  borderWidth: 0,
                  iconMargin: 0,
                  loginType: "loginShowHide",
                  background: [
                    {
                      "label": "颜色",
                      "isThemeColor": false,
                      "type": "color",
                      "color": "rgba(255, 255, 255,0)"
                    }
                  ],
                }),
                new Button({
                  top: 210,
                  left: 48,
                  width: 360,
                  height: 48,
                  fontSize: 18,
                  elementInLayoutId: 13,
                  content: "登录",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  bgColorIsThemeColor: true,
                  borderWidth: 0,
                  background: [
                    {
                      isThemeColor: true,
                      label: "颜色",
                      type: "color"
                    }
                  ],
                  loginType: "loginButton"
                }),
                new Text({
                  top: 278,
                  left: 48,
                  elementInLayoutId: 14,
                  content: "新用户注册",
                  fontSize: 15,
                  textIsThemeColor: true,
                  pointer: true,
                  loginType: "loginRegister"
                }),
                new Text({
                  top: 168,
                  left: 48,
                  width: 360,
                  height: 34,
                  lineHeight: 34,
                  elementInLayoutId: 41,
                  fontSize: 14,
                  content: "用户名或密码不能为空！",
                  color: "#ff4e4e",
                  background: [
                    {
                      color: "rgb(255, 237, 237)",
                      isThemeColor: false,
                      label: "颜色",
                      type: "color"
                    }
                  ],
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  paddingLeft: 15,
                  paddingRight: 15,
                  borderWidth: 0,
                  loginType: "loginError"
                })
              ]
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              elementOptions: [
                new Input({
                  top: 40,
                  left: 48,
                  width: 360,
                  height: 48,
                  elementInLayoutId: 15,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconTel,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "手机号",
                  readonly: true,
                  loginType: "loginPhone"
                }),
                new Input({
                  top: 112,
                  left: 48,
                  width: 360,
                  height: 48,
                  elementInLayoutId: 16,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconTest,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "验证码",
                  readonly: true,
                  loginType: "loginTest"
                }),
                new Button({
                  top: 112,
                  left: 321,
                  width: 75,
                  height: 48,
                  zIndex: 2,
                  lineHeight: 48,
                  fontWeight: 400,
                  elementInLayoutId: 17,
                  content: "获取验证码",
                  bgColor: "rgba(255, 255, 255,0)",
                  borderWidth: 0,
                  fontSize: 15,
                  textIsThemeColor: true,
                  loginType: "loginGetTest",
                  background: [
                    {
                      "label": "颜色",
                      "isThemeColor": false,
                      "type": "color",
                      "color": "rgba(255, 255, 255,0)"
                    }
                  ],
                }),
                new Button({
                  top: 210,
                  left: 48,
                  width: 360,
                  height: 48,
                  fontSize: 18,
                  elementInLayoutId: 18,
                  content: "登录",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  bgColorIsThemeColor: true,
                  borderWidth: 0,
                  background: [
                    {
                      isThemeColor: true,
                      label: "颜色",
                      type: "color"
                    }
                  ],
                  loginType: "loginButton"
                }),
                new Text({
                  top: 278,
                  left: 48,
                  elementInLayoutId: 19,
                  content: "新用户注册",
                  fontSize: 15,
                  textIsThemeColor: true,
                  pointer: true,
                  loginType: "loginRegister"
                }),
                new Text({
                  top: 168,
                  left: 48,
                  width: 360,
                  height: 34,
                  lineHeight: 34,
                  elementInLayoutId: 42,
                  fontSize: 14,
                  content: "手机号或验证码不能为空！",
                  color: "#ff4e4e",
                  background: [
                    {
                      color: "rgb(255, 237, 237)",
                      isThemeColor: false,
                      label: "颜色",
                      type: "color"
                    }
                  ],
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  paddingLeft: 15,
                  paddingRight: 15,
                  borderWidth: 0,
                  loginType: "loginError"
                }),
                new Button({
                  top: 112,
                  left: 295,
                  width: 110,
                  height: 48,
                  zIndex: 2,
                  lineHeight: 48,
                  fontWeight: 400,
                  elementInLayoutId: 43,
                  content: "30s后重新获取",
                  bgColor: "rgba(255, 255, 255,0)",
                  borderWidth: 0,
                  fontSize: 15,
                  textIsThemeColor: true,
                  loginType: "loginCountDown",
                  background: [
                    {
                      "label": "颜色",
                      "isThemeColor": false,
                      "type": "color",
                      "color": "rgba(255, 255, 255,0)"
                    }
                  ],
                })
              ]
            }
          ]
        },
        // 安全验证
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              elementOptions: [
                new Button({
                  top: 30,
                  left: 24,
                  width: 100,
                  height: 20,
                  lineHeight: 20,
                  fontWeight: 400,
                  elementInLayoutId: 20,
                  content: "返回",
                  bgColor: "rgba(255, 255, 255,0)",
                  color: "#999999",
                  borderWidth: 0,
                  iconWidth: 16,
                  iconType: "icon",
                  iconSrc: "1E4D5B682FE13666",
                  iconColor: "#999999",
                  iconMargin: 4,
                  loginType: "loginReturn"
                }),
                new Text({
                  top: 30,
                  left: 404,
                  elementInLayoutId: 21,
                  content: "客服",
                  color: "#999999",
                  loginType: "loginService"
                }),
                new Text({
                  top: 80,
                  left: 48,
                  width: 110,
                  height: 36,
                  elementInLayoutId: 22,
                  content: "安全验证",
                  fontSize: 26,
                  lineHeight: 36,
                  color: "#000000"
                }),
                new Text({
                  top: 128,
                  left: 48,
                  width: 360,
                  height: 20,
                  elementInLayoutId: 23,
                  content: "为了你的账号安全，请再次进行短信验证",
                  lineHeight: 20,
                  color: "#999999",
                  loginType: "searchButton"
                }),
                new Text({
                  top: 178,
                  left: 48,
                  elementInLayoutId: 24,
                  content: "请输入",
                  fontSize: 16,
                  lineHeight: 22,
                  color: "#999999",
                  loginType: "searchButton"
                }),
                new Text({
                  top: 178,
                  left: 100,
                  elementInLayoutId: 25,
                  content: "139****6566",
                  fontSize: 16,
                  lineHeight: 22,
                  textIsThemeColor: true,
                  loginType: "searchTestNum"
                }),
                new Text({
                  top: 178,
                  left: 201,
                  elementInLayoutId: 26,
                  content: "收到的验证码",
                  fontSize: 16,
                  lineHeight: 22,
                  color: "#999999"
                }),
                new Input({
                  top: 230,
                  left: 48,
                  width: 360,
                  height: 48,
                  elementInLayoutId: 27,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconTest,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "验证码",
                  readonly: true,
                  loginType: "searchTestInput"
                }),
                new Button({
                  top: 230,
                  left: 321,
                  width: 75,
                  height: 48,
                  zIndex: 2,
                  lineHeight: 48,
                  fontWeight: 400,
                  elementInLayoutId: 28,
                  content: "获取验证码",
                  bgColor: "rgba(255, 255, 255,0)",
                  borderWidth: 0,
                  fontSize: 15,
                  textIsThemeColor: true,
                  loginType: "loginGetTest"
                }),
                new Button({
                  top: 328,
                  left: 48,
                  width: 360,
                  height: 48,
                  fontSize: 18,
                  elementInLayoutId: 29,
                  content: "验证",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  bgColorIsThemeColor: true,
                  loginType: "loginTestBtn1"
                })
              ]
            }
          ]
        },
        // 设置独立登录密码
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              elementOptions: [
                new Button({
                  top: 30,
                  left: 24,
                  width: 100,
                  height: 20,
                  lineHeight: 20,
                  fontWeight: 400,
                  elementInLayoutId: 30,
                  content: "返回",
                  bgColor: "rgba(255, 255, 255,0)",
                  color: "#999999",
                  borderWidth: 0,
                  iconWidth: 16,
                  iconType: "icon",
                  iconSrc: "1E4D5B682FE13666",
                  iconColor: "#999999",
                  iconMargin: 4,
                  loginType: "loginReturn"
                }),
                new Text({
                  top: 30,
                  left: 404,
                  elementInLayoutId: 31,
                  content: "客服",
                  color: "#999999",
                  loginType: "loginService"
                }),
                new Text({
                  top: 80,
                  left: 48,
                  width: 360,
                  height: 36,
                  elementInLayoutId: 32,
                  content: "设置独立登录密码",
                  fontSize: 26,
                  lineHeight: 36,
                  color: "#000000"
                }),
                new Text({
                  top: 128,
                  left: 48,
                  width: 360,
                  height: 20,
                  elementInLayoutId: 33,
                  content: "为了你的账号安全，请设置登录网站的独立密码",
                  lineHeight: 20,
                  color: "#999999"
                }),
                new Input({
                  top: 178,
                  left: 48,
                  width: 360,
                  height: 48,
                  elementInLayoutId: 34,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconPassword,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "密码",
                  inputTypeVal: "password",
                  readonly: true,
                  loginType: "loginPasswordNew1"
                }),
                new Button({
                  top: 193,
                  left: 378,
                  width: 18,
                  height: 18,
                  zIndex: 2,
                  elementInLayoutId: 35,
                  content: "",
                  iconWidth: 18,
                  iconType: "icon",
                  iconSrc: "B4F974FFF34D7AA8",
                  iconColor: "#ACB4BF",
                  bgColor: "rgba(255, 255, 255,0)",
                  borderWidth: 0,
                  iconMargin: 0,
                  loginType: "loginShowHide1"
                }),
                new Input({
                  top: 250,
                  left: 48,
                  width: 360,
                  height: 48,
                  elementInLayoutId: 36,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconPassword,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "请再次输入密码",
                  readonly: true,
                  loginType: "loginPasswordNew2"
                }),
                new Button({
                  top: 265,
                  left: 378,
                  width: 18,
                  height: 18,
                  zIndex: 2,
                  elementInLayoutId: 37,
                  content: "",
                  iconWidth: 18,
                  iconType: "icon",
                  iconSrc: "B4F974FFF34D7AA8",
                  iconColor: "#ACB4BF",
                  bgColor: "rgba(255, 255, 255,0)",
                  borderWidth: 0,
                  iconMargin: 0,
                  loginType: "loginShowHide2"
                }),
                new Button({
                  top: 348,
                  left: 48,
                  width: 360,
                  height: 48,
                  fontSize: 18,
                  elementInLayoutId: 38,
                  content: "验证",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  bgColorIsThemeColor: true,
                  loginType: "loginTestBtn2"
                })
              ]
            }
          ]
        },
        // 短信注册
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              elementOptions: [
                new Button({
                  top: 25,
                  left: 21,
                  width: 100,
                  height: 20,
                  lineHeight: 20,
                  fontWeight: 400,
                  elementInLayoutId: 30,
                  content: "返回上一步",
                  bgColor: "rgba(255, 255, 255,0)",
                  color: "#999999",
                  borderWidth: 0,
                  iconWidth: 16,
                  iconType: "icon",
                  iconSrc: "1E4D5B682FE13666",
                  iconColor: "#999999",
                  iconMargin: 4,
                  loginType: "loginReturn"
                }),
                new Text({
                  top: 80,
                  left: 48,
                  width: 360,
                  height: 36,
                  elementInLayoutId: 32,
                  content: "请输入真实姓名",
                  fontSize: 26,
                  lineHeight: 36,
                  color: "#000000"
                }),
                new Input({
                  top: 150,
                  left: 48,
                  width: 360,
                  height: 48,
                  elementInLayoutId: 34,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconPassword,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "姓名",
                  loginType: "loginName"
                }),
                new Text({
                  top: 210,
                  left: 48,
                  width: 360,
                  height: 34,
                  lineHeight: 34,
                  elementInLayoutId: 41,
                  fontSize: 14,
                  content: "请输入姓名",
                  color: "#ff4e4e",
                  background: [
                    {
                      color: "rgb(255, 237, 237)",
                      isThemeColor: false,
                      label: "颜色",
                      type: "color"
                    }
                  ],
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  paddingLeft: 15,
                  paddingRight: 15,
                  borderWidth: 0,
                  loginType: "loginError"
                }),
                new Button({
                  top: 255,
                  left: 48,
                  width: 360,
                  height: 48,
                  fontSize: 18,
                  elementInLayoutId: 38,
                  content: "确定",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  bgColorIsThemeColor: true,
                  loginType: "loginTestBtn2"
                })
              ]
            }
          ]
        }
      ]
    }).rows
  }
]
/**
 * 大屏文本默认配置数据
 */
export const bs = []

/**
 * app登陆默认配置数据
 */
export const appHome = [
  {
    styleName: "自由布局",
    thumbnail: require("../../assets/images/leftMenu/layout/layout_1.png"),
    pluginName: ["loginEngineComponentPlugin"],
    appId: "",
    background: [
      {
        color: "#FFFFFF",
        isThemeColor: false,
        label: "颜色",
        type: "color"
      }
    ],
    titleOptions: [
      {
        type: "top",
        isShow: true,
        height: 200,
        elementOptions: [
          {
            innerElement: "cxTabs",
            isActive: false,
            isShow: true,
            type: "classification",
            elementInLayoutId: 0,
            options: new Tabs({
              singleTabs: false,
              top: 130,
              left: 6,
              width: 360,
              height: 62,
              lineHeight: 52,
              hoverLineHeight: 52,
              tabWidth: 180,
              tabHeight: 62,
              color: "#8A8B99",
              bgColor: "rgba(255,255,255,0)",
              hoverBgColor: "rgba(255,255,255,0)",
              hoverBgColorIsThemeColor: false,
              tabBackgroundColor: "rgba(255,255,255,0)",
              fontSize: 22,
              hoverFontSize: 22,
              textAlign: "center",
              hoverTextAlign: "center",
              tabsList: [
                { name: "手机号登录", content: "手机号登录", isHide: false },
                { name: "扫码登录", content: "扫码登录", isHide: false },
                { name: "机构账号登录", content: "机构账号登录", isHide: true },
                { name: "短信验证码登录", content: "短信验证码登录", isHide: true }
              ],
              hoverFontWeight: "500",
              hoverTextIsThemeColor: true,
              borderWidth: [0, 0, 1],
              borderColor: "#ECECF1",
              hoverBorderWidth: [0, 0, 2],
              textLimitLines: 7,
              hoverBorderIsThemeColor: true
            })
          },
          {
            innerElement: "imageComponent",
            isShow: true,
            type: "classification",
            elementInLayoutId: 1,
            options: new Image({
              top: 48,
              left: 80,
              width: 192,
              height: 44,
              imgSrc: "https://p.ananas.chaoxing.com/star3/origin/bcdbc474b726d89db32daa9c18e1bb51.png"
            })
          }
        ]
      },
      {
        type: "bottom",
        elementOptions: []
      },
      {
        type: "left",
        elementOptions: []
      },
      {
        type: "right",
        elementOptions: []
      }
    ],
    rows: new LayoutGenerator({
      // row的数量需与tab的数量同步
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              elementOptions: [
                new Input({
                  top: 40,
                  left: 6,
                  width: 360,
                  height: 48,
                  elementInLayoutId: 2,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconTel,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "手机号",
                  readonly: true,
                  loginType: "loginPhone"
                }),
                new Button({
                  top: 127,
                  left: 270,
                  width: 18,
                  height: 18,
                  zIndex: 2,
                  lineHeight: 48,
                  elementInLayoutId: 40,
                  content: "",
                  iconWidth: 18,
                  iconType: "icon",
                  iconSrc: "B4F974FFF34D7AA8",
                  iconColor: "#ACB4BF",
                  bgColor: "rgba(255, 255, 255,0)",
                  borderWidth: 0,
                  iconMargin: 0,
                  loginType: "loginShowHide"
                }),
                new Button({
                  top: 112,
                  left: 296,
                  width: 70,
                  height: 48,
                  zIndex: 2,
                  lineHeight: 48,
                  fontWeight: 400,
                  elementInLayoutId: 3,
                  content: "忘记密码",
                  color: "#6B89B2",
                  bgColor: "rgba(255, 255, 255,0)",
                  borderWidth: 0,
                  loginType: "loginForgetPassword"
                }),
                new Input({
                  top: 112,
                  left: 6,
                  width: 360,
                  height: 48,
                  elementInLayoutId: 4,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconPassword,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "密码",
                  inputTypeVal: "password",
                  readonly: true,
                  loginType: "loginPassword"
                }),
                new Text({
                  top: 168,
                  left: 6,
                  width: 360,
                  height: 34,
                  lineHeight: 34,
                  elementInLayoutId: 39,
                  fontSize: 14,
                  content: "手机号或密码不能为空！",
                  color: "#ff4e4e",
                  background: [
                    {
                      color: "rgb(255, 237, 237)",
                      isThemeColor: false,
                      label: "颜色",
                      type: "color"
                    }
                  ],
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  paddingLeft: 15,
                  paddingRight: 15,
                  borderWidth: 0,
                  loginType: "loginError"
                }),
                new Button({
                  top: 210,
                  left: 6,
                  width: 360,
                  height: 48,
                  fontSize: 18,
                  elementInLayoutId: 5,
                  content: "登录",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  bgColorIsThemeColor: true,
                  borderWidth: 0,
                  background: [
                    {
                      isThemeColor: true,
                      label: "颜色",
                      type: "color"
                    }
                  ],
                  loginType: "loginButton"
                }),
                new Text({
                  top: 278,
                  left: 6,
                  elementInLayoutId: 6,
                  content: "新用户注册",
                  fontSize: 15,
                  color: "#2675FA",
                  textIsThemeColor: true,
                  pointer: true,
                  loginType: "loginRegister"
                })
              ]
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              baseComponentBoxOptions: {
                bgColor: "#FFFFFF"
              },
              elementOptions: [
                new Iframe({
                  top: 40,
                  left: 76,
                  width: 220,
                  height: 260,
                  iframeUrl:
                    "https://passport2.chaoxing.com/cloudscanlogin?mobiletip=%E6%99%BA%E6%85%A7%E9%97%A8%E6%88%B7&pcrefer=",
                  elementInLayoutId: 7,
                  loginType: "loginCode"
                })
                // new Text({
                //   top: 360,
                //   left: 78,
                //   width: 300,
                //   elementInLayoutId: 8,
                //   content: "使用学习通app扫码登录",
                //   fontSize: 18,
                //   color: "#474C59",
                //   textAlign: "center",
                // }),
              ]
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              elementOptions: [
                // new Input({
                //   top: 40,
                //   left: 48,
                //   width: 360,
                //   height: 48,
                //   elementInLayoutId: 9,
                //   borderWidth: 1,
                //   borderColor: "#ECECF1",
                //   borderTopLeftRadius : 6,
                //   borderTopRightRadius : 6,
                //   borderBottomLeftRadius : 6,
                //   borderBottomRightRadius : 6,
                //   iconWidth: 24,
                //   iconType: "img",
                //   iconSrc: iconSchool,
                //   paddingLeft: 12,
                //   paddingRight: 12,
                //   placeholder: "学校/单位",
                //   loginType: "loginSchool"
                // }),
                new Input({
                  top: 40,
                  left: 6,
                  width: 360,
                  height: 48,
                  elementInLayoutId: 10,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconId,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "学号/工号",
                  readonly: true,
                  loginType: "loginId"
                }),
                new Input({
                  top: 112,
                  left: 6,
                  width: 360,
                  height: 48,
                  elementInLayoutId: 11,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconPassword,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "密码",
                  inputTypeVal: "password",
                  readonly: true,
                  loginType: "loginPassword"
                }),
                new Button({
                  top: 127,
                  left: 334,
                  width: 18,
                  height: 18,
                  zIndex: 2,
                  lineHeight: 48,
                  elementInLayoutId: 12,
                  content: "",
                  iconWidth: 18,
                  iconType: "icon",
                  iconSrc: "B4F974FFF34D7AA8",
                  iconColor: "#ACB4BF",
                  bgColor: "rgba(255, 255, 255,0)",
                  borderWidth: 0,
                  iconMargin: 0,
                  loginType: "loginShowHide"
                }),
                new Button({
                  top: 210,
                  left: 6,
                  width: 360,
                  height: 48,
                  fontSize: 18,
                  elementInLayoutId: 13,
                  content: "登录",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  bgColorIsThemeColor: true,
                  borderWidth: 0,
                  background: [
                    {
                      isThemeColor: true,
                      label: "颜色",
                      type: "color"
                    }
                  ],
                  loginType: "loginButton"
                }),
                new Text({
                  top: 278,
                  left: 6,
                  elementInLayoutId: 14,
                  content: "新用户注册",
                  fontSize: 15,
                  textIsThemeColor: true,
                  pointer: true,
                  loginType: "loginRegister"
                }),
                new Text({
                  top: 168,
                  left: 6,
                  width: 360,
                  height: 34,
                  lineHeight: 34,
                  elementInLayoutId: 41,
                  fontSize: 14,
                  content: "用户名或密码不能为空！",
                  color: "#ff4e4e",
                  background: [
                    {
                      color: "rgb(255, 237, 237)",
                      isThemeColor: false,
                      label: "颜色",
                      type: "color"
                    }
                  ],
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  paddingLeft: 15,
                  paddingRight: 15,
                  borderWidth: 0,
                  loginType: "loginError"
                })
              ]
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              elementOptions: [
                new Input({
                  top: 40,
                  left: 6,
                  width: 360,
                  height: 48,
                  elementInLayoutId: 15,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconTel,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "手机号",
                  readonly: true,
                  loginType: "loginPhone"
                }),
                new Input({
                  top: 112,
                  left: 6,
                  width: 360,
                  height: 48,
                  elementInLayoutId: 16,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconTest,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "验证码",
                  readonly: true,
                  loginType: "loginTest"
                }),
                new Button({
                  top: 112,
                  left: 290,
                  width: 75,
                  height: 48,
                  zIndex: 2,
                  lineHeight: 48,
                  fontWeight: 400,
                  elementInLayoutId: 17,
                  content: "获取验证码",
                  bgColor: "rgba(255, 255, 255,0)",
                  borderWidth: 0,
                  fontSize: 15,
                  textIsThemeColor: true,
                  loginType: "loginGetTest"
                }),
                new Button({
                  top: 210,
                  left: 6,
                  width: 360,
                  height: 48,
                  fontSize: 18,
                  elementInLayoutId: 18,
                  content: "登录",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  bgColorIsThemeColor: true,
                  borderWidth: 0,
                  background: [
                    {
                      isThemeColor: true,
                      label: "颜色",
                      type: "color"
                    }
                  ],
                  loginType: "loginButton"
                }),
                new Text({
                  top: 278,
                  left: 6,
                  elementInLayoutId: 19,
                  content: "新用户注册",
                  fontSize: 15,
                  textIsThemeColor: true,
                  pointer: true,
                  loginType: "loginRegister"
                }),
                new Text({
                  top: 168,
                  left: 6,
                  width: 360,
                  height: 34,
                  lineHeight: 34,
                  elementInLayoutId: 42,
                  fontSize: 14,
                  content: "手机号或验证码不能为空！",
                  color: "#ff4e4e",
                  background: [
                    {
                      color: "rgb(255, 237, 237)",
                      isThemeColor: false,
                      label: "颜色",
                      type: "color"
                    }
                  ],
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  paddingLeft: 15,
                  paddingRight: 15,
                  borderWidth: 0,
                  loginType: "loginError"
                }),
                new Button({
                  top: 112,
                  left: 295,
                  width: 110,
                  height: 48,
                  zIndex: 2,
                  lineHeight: 48,
                  fontWeight: 400,
                  elementInLayoutId: 43,
                  content: "30s后重新获取",
                  bgColor: "rgba(255, 255, 255,0)",
                  borderWidth: 0,
                  fontSize: 15,
                  textIsThemeColor: true,
                  loginType: "loginCountDown"
                })
              ]
            }
          ]
        },
        // 安全验证
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              elementOptions: [
                new Button({
                  top: 30,
                  left: 24,
                  width: 100,
                  height: 20,
                  lineHeight: 20,
                  fontWeight: 400,
                  elementInLayoutId: 20,
                  content: "返回",
                  bgColor: "rgba(255, 255, 255,0)",
                  color: "#999999",
                  borderWidth: 0,
                  iconWidth: 16,
                  iconType: "icon",
                  iconSrc: "1E4D5B682FE13666",
                  iconColor: "#999999",
                  iconMargin: 4,
                  loginType: "loginReturn"
                }),
                new Text({
                  top: 30,
                  left: 404,
                  elementInLayoutId: 21,
                  content: "客服",
                  color: "#999999",
                  loginType: "loginService"
                }),
                new Text({
                  top: 80,
                  left: 48,
                  width: 110,
                  height: 36,
                  elementInLayoutId: 22,
                  content: "安全验证",
                  fontSize: 26,
                  lineHeight: 36,
                  color: "#000000"
                }),
                new Text({
                  top: 128,
                  left: 48,
                  width: 360,
                  height: 20,
                  elementInLayoutId: 23,
                  content: "为了你的账号安全，请再次进行短信验证",
                  lineHeight: 20,
                  color: "#999999",
                  loginType: "searchButton"
                }),
                new Text({
                  top: 178,
                  left: 48,
                  elementInLayoutId: 24,
                  content: "请输入",
                  fontSize: 16,
                  lineHeight: 22,
                  color: "#999999",
                  loginType: "searchButton"
                }),
                new Text({
                  top: 178,
                  left: 100,
                  elementInLayoutId: 25,
                  content: "139****6566",
                  fontSize: 16,
                  lineHeight: 22,
                  textIsThemeColor: true,
                  loginType: "searchTestNum"
                }),
                new Text({
                  top: 178,
                  left: 201,
                  elementInLayoutId: 26,
                  content: "收到的验证码",
                  fontSize: 16,
                  lineHeight: 22,
                  color: "#999999"
                }),
                new Input({
                  top: 230,
                  left: 48,
                  width: 360,
                  height: 48,
                  elementInLayoutId: 27,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconTest,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "验证码",
                  readonly: true,
                  loginType: "searchTestInput"
                }),
                new Button({
                  top: 230,
                  left: 321,
                  width: 75,
                  height: 48,
                  zIndex: 2,
                  lineHeight: 48,
                  fontWeight: 400,
                  elementInLayoutId: 28,
                  content: "获取验证码",
                  bgColor: "rgba(255, 255, 255,0)",
                  borderWidth: 0,
                  fontSize: 15,
                  textIsThemeColor: true,
                  loginType: "loginGetTest"
                }),
                new Button({
                  top: 328,
                  left: 48,
                  width: 360,
                  height: 48,
                  fontSize: 18,
                  elementInLayoutId: 29,
                  content: "验证",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  bgColorIsThemeColor: true,
                  loginType: "loginTestBtn1"
                })
              ]
            }
          ]
        },
        // 设置独立登录密码
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              elementOptions: [
                new Button({
                  top: 30,
                  left: 24,
                  width: 100,
                  height: 20,
                  lineHeight: 20,
                  fontWeight: 400,
                  elementInLayoutId: 30,
                  content: "返回",
                  bgColor: "rgba(255, 255, 255,0)",
                  color: "#999999",
                  borderWidth: 0,
                  iconWidth: 16,
                  iconType: "icon",
                  iconSrc: "1E4D5B682FE13666",
                  iconColor: "#999999",
                  iconMargin: 4,
                  loginType: "loginReturn"
                }),
                new Text({
                  top: 30,
                  left: 404,
                  elementInLayoutId: 31,
                  content: "客服",
                  color: "#999999",
                  loginType: "loginService"
                }),
                new Text({
                  top: 80,
                  left: 48,
                  width: 360,
                  height: 36,
                  elementInLayoutId: 32,
                  content: "设置独立登录密码",
                  fontSize: 26,
                  lineHeight: 36,
                  color: "#000000"
                }),
                new Text({
                  top: 128,
                  left: 48,
                  width: 360,
                  height: 20,
                  elementInLayoutId: 33,
                  content: "为了你的账号安全，请设置登录网站的独立密码",
                  lineHeight: 20,
                  color: "#999999"
                }),
                new Input({
                  top: 178,
                  left: 48,
                  width: 360,
                  height: 48,
                  elementInLayoutId: 34,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconPassword,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "密码",
                  inputTypeVal: "password",
                  readonly: true,
                  loginType: "loginPasswordNew1"
                }),
                new Button({
                  top: 193,
                  left: 378,
                  width: 18,
                  height: 18,
                  zIndex: 2,
                  elementInLayoutId: 35,
                  content: "",
                  iconWidth: 18,
                  iconType: "icon",
                  iconSrc: "B4F974FFF34D7AA8",
                  iconColor: "#ACB4BF",
                  bgColor: "rgba(255, 255, 255,0)",
                  borderWidth: 0,
                  iconMargin: 0,
                  loginType: "loginShowHide1"
                }),
                new Input({
                  top: 250,
                  left: 48,
                  width: 360,
                  height: 48,
                  elementInLayoutId: 36,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconPassword,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "请再次输入密码",
                  readonly: true,
                  loginType: "loginPasswordNew2"
                }),
                new Button({
                  top: 265,
                  left: 378,
                  width: 18,
                  height: 18,
                  zIndex: 2,
                  elementInLayoutId: 37,
                  content: "",
                  iconWidth: 18,
                  iconType: "icon",
                  iconSrc: "B4F974FFF34D7AA8",
                  iconColor: "#ACB4BF",
                  bgColor: "rgba(255, 255, 255,0)",
                  borderWidth: 0,
                  iconMargin: 0,
                  loginType: "loginShowHide2"
                }),
                new Button({
                  top: 348,
                  left: 48,
                  width: 360,
                  height: 48,
                  fontSize: 18,
                  elementInLayoutId: 38,
                  content: "验证",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  bgColorIsThemeColor: true,
                  loginType: "loginTestBtn2"
                })
              ]
            }
          ]
        },
        // 短信注册
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              elementOptions: [
                new Button({
                  top: 25,
                  left: 21,
                  width: 100,
                  height: 20,
                  lineHeight: 20,
                  fontWeight: 400,
                  elementInLayoutId: 30,
                  content: "返回上一步",
                  bgColor: "rgba(255, 255, 255,0)",
                  color: "#999999",
                  borderWidth: 0,
                  iconWidth: 16,
                  iconType: "icon",
                  iconSrc: "1E4D5B682FE13666",
                  iconColor: "#999999",
                  iconMargin: 4,
                  loginType: "loginReturn"
                }),
                new Text({
                  top: 80,
                  left: 48,
                  width: 286,
                  height: 36,
                  elementInLayoutId: 32,
                  content: "请输入真实姓名",
                  fontSize: 26,
                  lineHeight: 36,
                  color: "#000000"
                }),
                new Input({
                  top: 150,
                  left: 48,
                  width: 286,
                  height: 48,
                  elementInLayoutId: 34,
                  borderWidth: 1,
                  borderColor: "#ECECF1",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  iconWidth: 24,
                  iconType: "img",
                  iconSrc: iconPassword,
                  textPaddingTypeFlag: 2,
                  paddingLeft: 12,
                  paddingRight: 12,
                  placeholder: "姓名",
                  loginType: "loginName"
                }),
                new Text({
                  top: 210,
                  left: 48,
                  width: 286,
                  height: 34,
                  lineHeight: 34,
                  elementInLayoutId: 41,
                  fontSize: 14,
                  content: "请输入姓名",
                  color: "#ff4e4e",
                  background: [
                    {
                      color: "rgb(255, 237, 237)",
                      isThemeColor: false,
                      label: "颜色",
                      type: "color"
                    }
                  ],
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  paddingLeft: 15,
                  paddingRight: 15,
                  borderWidth: 0,
                  loginType: "loginError"
                }),
                new Button({
                  top: 255,
                  left: 48,
                  width: 286,
                  height: 48,
                  fontSize: 18,
                  elementInLayoutId: 38,
                  content: "确定",
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  borderBottomLeftRadius: 6,
                  borderBottomRightRadius: 6,
                  bgColorIsThemeColor: true,
                  loginType: "loginTestBtn2"
                })
              ]
            }
          ]
        }
      ]
    }).rows
  }
]
